import React, { useEffect, useState } from "react";
import styles from "./styles.module.css";
import SVGIcon from "../../componentsV2/atoms/SVGIcon";
import Button from "../../componentsV2/atoms/Button/Button";
import usePriceDiscounts, {
    getYearSave,
    parsePrice,
} from "../../componentsV2/templates/Dashboard/usePriceDiscounts";
import { PLANS_CATEGORIES, PLANS_TYPE } from "../../constants";
import useUserAccessHook from "../account/useUserAccessHook";
import { useSelector } from "react-redux";
import useHelperFunctions from "../../componentsV2/helperFunctions";
import Progress from "../../componentsV2/atoms/Progress/Progress";
import BuyMore from "../../componentsV2/Pages/WebTune/BuyMore";
import { colors } from "@material-ui/core";
import { OfflinePaymentModal } from "./PriceCard";

const KeyFeatures = [
    {
        icon: <SVGIcon src={"/New UI/SVG/bold-link.svg"} size={22} />,
        title: "Linking made easy",
        subText:
            "Finding internal links is hard. It need not be. Completely automate the process.",
    },
    {
        icon: <SVGIcon src={"/New UI/SVG/graph-rise.svg"} size={22} />,
        title: "Improve crawl and indexation",
        subText:
            "Find thousands of relevant linking opportunities across your domain and distribute link equity",
    },
    {
        icon: <SVGIcon src={"/New UI/SVG/paper-plane.svg"} size={20} />,
        title: "Say goodbye to manual efforts",
        subText:
            "Deploy as many changes as you want in a click. No more spending hours.",
    },
];

export const LmAddOnCheck = ({
    plansType,
    isDeal = false,
    customClass,
    isThisCurr = false,
    checked = false,
    handleChecked = () => {},
    setDefaultAddOnChecked = () => {},
    price,
}) => {
    const currency = useSelector((state) => state.auth.currency);
    const currencySymbol = currency == "INR" ? "₹" : "$";
    const { interlinking_purchased_pages_quantity, interlinking_status } =
        useSelector((state) => state.otherInfo?.subscriptionInfo);
    return (
        <div className={styles.lmAddOnCheckWrapper}>
            <div className={styles.lmAddOnCheckTitle}>
                Add-on
                {interlinking_status != 0 && (
                    <div className={styles.newTag}>
                        {interlinking_purchased_pages_quantity == 0
                            ? "New"
                            : "Activated"}
                    </div>
                )}
            </div>
            <ul className={customClass.checksList} style={{ marginTop: "5px" }}>
                <li style={{ alignItems: "flex-start" }}>
                    <div
                        className={customClass.check}
                        style={{
                            marginTop: 3,
                            background: isThisCurr
                                ? checked && interlinking_status != 0
                                    ? "white"
                                    : "transparent"
                                : checked && interlinking_status != 0
                                ? "#014dc5"
                                : "transparent",
                            width:
                                checked && interlinking_status != 0 ? 15 : 13,
                            aspectRatio: "1/1",
                            border: "1px solid white",
                        }}
                        onClick={() => {
                            handleChecked(!checked);
                            setDefaultAddOnChecked(!checked);
                        }}
                    >
                        <SVGIcon
                            size={checked && interlinking_status != 0 ? 13 : 15}
                            src={
                                checked && interlinking_status != 0
                                    ? "/New UI/SVG/check.svg"
                                    : "/New UI/SVG/blank-circle.svg"
                            }
                            style={{
                                color:
                                    checked && interlinking_status != 0
                                        ? "#fff"
                                        : "rgb(64, 123, 255)",
                            }}
                        />
                    </div>
                    {plansType == 2 && isDeal ? (
                        <div>
                            Link Manager {price}
                            /mo
                            <div
                                style={{
                                    color: isThisCurr ? "#d3d3d3" : "gray",
                                    marginTop: 10,
                                }}
                            >
                                1000 pages included
                                <br />
                                {currencySymbol}
                                {currency == "USD" ? "5" : "425"}/500 pages
                            </div>
                        </div>
                    ) : (
                        <div>
                            Link Manager {price}
                            /mo
                            <div
                                style={{
                                    color: isThisCurr ? "whitesmoke" : "gray",
                                    marginTop: 10,
                                }}
                            >
                                1000 pages included
                                <br />
                                {currencySymbol}
                                {currency == "USD" ? "5" : "425"}/500 pages
                            </div>
                        </div>
                    )}
                </li>
            </ul>
        </div>
    );
};

const LmAddOnCard = ({
    defaultAddOnChecked = false,
    setDefaultAddOnChecked = () => {},
    plansToggler,
    plans = [],
    getDiscount = () => {},
    isOpenChat = false,
}) => {
    const { trialUser, isFreeForever, plan_type } = useUserAccessHook();
    const { interlinking_purchased_pages_quantity, interlinking_status } =
        useSelector((state) => state.otherInfo?.subscriptionInfo);
    const currency = useSelector((state) => state.auth.currency);
    const currencySymbol = currency == "INR" ? "₹" : "$";
    const [validPlanCost, setValidPlanCost] = useState(1);
    // const [plansToggler, setplansToggler] = useState(
    //     plan_type || PLANS_TYPE.YEARLY,
    // );
    const [loading, setLoading] = useState(false);
    const [buyPagesModal, setBuyPagesModal] = useState(false);
    const [isOfflinePaymentWarning, setIsOfflinePaymentWarning] =
        useState(false);
    useEffect(() => {
        if (plans.length) {
            let tempValidPlan = plans.find(
                (vp) =>
                    vp?.plan_cost > 0 &&
                    vp?.plan_type == plansToggler &&
                    vp.plan_category == PLANS_CATEGORIES.INTER_LINKING,
            );
            setValidPlanCost(tempValidPlan?.plan_cost || {});
        }
    }, [plans, plansToggler]);

    const handleTryDemo = () => {
        if (isOpenChat) {
            setIsOfflinePaymentWarning(true);
            return;
        }
        if (
            ((trialUser || isFreeForever) && interlinking_status != 0) ||
            (interlinking_status == 0 && isFreeForever)
        ) {
            setDefaultAddOnChecked(true);
            const container = document.getElementById("planContainer");
            container.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest",
            });
        } else {
            setBuyPagesModal({
                isShow: true,
                domainId: null,
            });
        }
    };

    return loading ? (
        <Progress height={"300px"} width={"90%"} />
    ) : (
        <div className={styles.lmAddOnCardWrapper}>
            <div className={styles._left}>
                <div className={styles._top}>
                    <div className={styles._line1}>
                        <div
                            className={styles.checkOnLmCard}
                            onClick={() => {
                                setDefaultAddOnChecked((ps) => !ps);
                            }}
                            style={{
                                background:
                                    defaultAddOnChecked &&
                                    interlinking_status != 0
                                        ? "#014dc5"
                                        : "#fff",
                            }}
                        >
                            <SVGIcon
                                size={
                                    defaultAddOnChecked &&
                                    interlinking_status != 0
                                        ? 13
                                        : 15
                                }
                                src={
                                    defaultAddOnChecked &&
                                    interlinking_status != 0
                                        ? "/New UI/SVG/check.svg"
                                        : "/New UI/SVG/blank-circle.svg"
                                }
                                style={{
                                    color:
                                        defaultAddOnChecked &&
                                        interlinking_status != 0
                                            ? "#fff"
                                            : "#014dc5",
                                }}
                            />
                        </div>
                        OPTIONAL ADD-ON{" "}
                        {interlinking_status != 0 && (
                            <div className={styles.newTag}>
                                {interlinking_purchased_pages_quantity == 0
                                    ? "New"
                                    : "Activated"}
                            </div>
                        )}
                    </div>
                    <div className={styles._line2}>Link Manager</div>
                    <div className={styles.dynamicPrices}>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                gap: "10px",
                            }}
                        >
                            <span
                                style={{
                                    visibility: !getDiscount(plansToggler)
                                        ? "hidden"
                                        : "unset",
                                }}
                                className={styles.cardPriceOriginalDis}
                            >
                                {parsePrice(
                                    validPlanCost,
                                    currency,
                                    plansToggler,
                                )}
                            </span>
                            <span
                                className={styles.offer}
                                style={{
                                    visibility: !getDiscount(plansToggler)
                                        ? "hidden"
                                        : "unset",
                                    marginLeft: "25px",
                                    marginBottom: "10px",
                                }}
                            >
                                <strong style={{ fontWeight: 500 }}>
                                    {getDiscount(plansToggler)}% OFF
                                </strong>{" "}
                                on Annual Plan
                            </span>
                        </div>

                        <div className={styles._line3Wrapper}>
                            <div className={styles._line3WrapperPrice}>
                                {parsePrice(
                                    validPlanCost,
                                    currency,
                                    plansToggler,
                                    getDiscount(plansToggler),
                                )}
                                <span className={styles._line3WrapperPriceMo}>
                                    {"/mo"}
                                </span>
                            </div>
                            <div className={styles._line3WrapperPriceBreakdown}>
                                1000 pages included <br />
                                {currencySymbol}
                                {currency == "USD" ? "5" : "425"}/500 pages
                                thereafter
                            </div>
                        </div>
                        <div
                            className={styles.youSave}
                            style={{
                                visibility: !getDiscount(plansToggler)
                                    ? "hidden"
                                    : "unset",
                            }}
                        >
                            Billed annually{" "}
                            <strong>
                                (Save{" "}
                                {getYearSave(
                                    validPlanCost,
                                    currency,
                                    plansToggler,
                                    getDiscount(plansToggler),
                                )}
                                /Year)
                            </strong>
                        </div>
                    </div>
                </div>
                <div className={styles._med}>
                    <Button
                        text={
                            interlinking_status == 0 && !isFreeForever
                                ? "Reactivate"
                                : trialUser || isFreeForever
                                ? "Grab The Deal"
                                : "Buy More Pages"
                        }
                        style={{
                            borderRadius: "25px",
                        }}
                        handler={handleTryDemo}
                        width={190}
                        height={44}
                        Icon={() => (
                            <SVGIcon
                                src={"/New UI/SVG/arrow-right-up.svg"}
                                size={16}
                                style={{ marginLeft: 2 }}
                            />
                        )}
                    />
                </div>
            </div>
            <div className={styles._midium}>
                {!!KeyFeatures.length &&
                    KeyFeatures.map((feat) => {
                        return (
                            <div className={styles.lmFeatCard}>
                                <div className={styles._left}>
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            alignItems: "flex-start",
                                        }}
                                    >
                                        {feat.icon}
                                    </div>
                                </div>
                                <div className={styles._right}>
                                    <div className={styles._title}>
                                        {feat.title}
                                    </div>
                                    {/* <div className={styles._subText}>
                                        {feat.subText}
                                    </div> */}
                                </div>
                            </div>
                        );
                    })}
            </div>
            <div className={styles._right}>
                <div className={styles.ssHolder}>
                    <SVGIcon src={"/New UI/SVG/link-manager-ss.svg"} />
                </div>
            </div>
            {isOfflinePaymentWarning && (
                <OfflinePaymentModal setModal={setIsOfflinePaymentWarning} />
            )}
            {buyPagesModal?.isShow && (
                <BuyMore
                    setBuyPagesModal={setBuyPagesModal}
                    domainId={buyPagesModal?.domainId}
                    screen={"Pricing LM Add-on Card"}
                />
            )}
        </div>
    );
};

export default LmAddOnCard;
